import _ from 'lodash'

const getFeatureToggles = userProfile => {
  if (_.isEmpty(userProfile)) {
    return {}
  }

  const currentUseCases = _.get(userProfile, ['usecase'])

  const isTextReportVisible = _.get(userProfile, [
    'xray_viewer',
    'show_text_report'
  ])

  const XRayHeaderFindings = _.get(userProfile, [
    'xray_viewer',
    'header_findings'
  ])
  const isTBFeedbackVisible = _.get(userProfile, ['xray_viewer', 'tb_feedback'])
  const isCovidFeedbackVisible = _.get(userProfile, [
    'xray_viewer',
    'covid_feedback'
  ])
  const isNoduleFeedbackVisible = _.get(userProfile, [
    'xray_viewer',
    'nodule_feedback'
  ])

  const isEditingReportEnabled = _.get(userProfile, ['pdf_report', 'edit'])
  const isReportDownloadEnabled = _.get(userProfile, ['pdf_report', 'download'])
  const isTabularReportEnabledOnEdit = _.get(userProfile, [
    'pdf_report',
    'show_tags'
  ])

  const isExternalReportShareEnabled = _.get(
    userProfile,
    ['pdf_report', 'share'],
    false
  )

  const enabledTreatmentDetails = _.get(userProfile, [
    'view_clients',
    'enable_treatment_details'
  ])

  const hasFeedback = isTBFeedbackVisible || isCovidFeedbackVisible
  const testDetails = _.get(userProfile, ['tests', 'details'], [])
  const tests = testDetails.map(tst => {
    const { choices } = tst
    const choicesObj = choices.reduce((acc, ch) => {
      acc[ch.key] = ch.label
      return acc
    }, {})
    return {
      choicesObj,
      ...tst
    }
  })

  const testsKeys = _.get(userProfile, ['tests', 'keys'], [])

  const enableAdditionalTestsFields = _.get(
    userProfile,
    ['tests', 'enable_additional_fields'],
    false
  )

  const hasGeneExpertTBTest = !_.isEmpty(_.find(tests, { key: 'genexpert' }))
  const hasTBLampTBTest = !_.isEmpty(_.find(tests, { key: 'tblamp' }))
  const hasCOVIDTests = !_.isEmpty(_.find(tests, { key: 'rtpcr' }))

  const hasTests = !_.isEmpty(tests)

  const hasDicomUpload = _.get(userProfile, ['upload_case', 'dicom'])
  const hasPngUpload = _.get(userProfile, ['upload_case', 'png'])

  const hasEnableAddVisit = _.get(userProfile, [
    'view_clients',
    'enable_add_visit'
  ])

  const hasEnableEditClient = _.get(userProfile, [
    'view_clients',
    'enable_edit_client'
  ])

  const xrayViewerHeaderFindings = _.get(userProfile, [
    'xray_viewer',
    'header_findings'
  ])

  const dashboardHeaderFindings = _.get(
    userProfile,
    ['dashboard', 'findings'],
    []
  ).map(useCase => ({
    label: _.get(useCase, 'label'),
    value: _.get(useCase, 'key')
  }))

  const dashboardDataSync = _.get(
    userProfile,
    ['dashboard', 'show_sync_status'],
    false
  )

  const viewClientTags = _.get(userProfile, [
    'view_clients',
    'ai_findings',
    'tag_list'
  ])

  const hasFullReportDownloadable = _.get(
    userProfile,
    ['full_report_dowloadable'],
    false
  )

  const hasHotSpotMap = _.get(
    userProfile,
    ['dashboard', 'show_hotspot_map'],
    false
  )
  const hasTBScoreViewClients = _.get(
    userProfile,
    ['view_clients', 'show_tbscore'],
    false
  )

  const hasNoduleScoreViewClients = _.get(
    userProfile,
    ['view_clients', 'show_nodulescore'],
    false
  )

  const hasNoduleScoreViewer = _.get(
    userProfile,
    ['xray_viewer', 'show_nodulescore'],
    false
  )

  const hasTBScoreViewer = _.get(
    userProfile,
    ['xray_viewer', 'show_tbscore'],
    false
  )

  const hasLiveUpdateOnClientList = _.get(
    userProfile,
    ['view_clients', 'live_update'],
    false
  )

  const hasColoredUploadDisclaimer = _.get(
    userProfile,
    ['colored_upload_disclaimer'],
    false
  )

  const scoreType = _.get(userProfile, ['result_type'], 'float')

  const isTBREnabled = _.get(userProfile, ['view_clients', 'enable_tbr'], false)

  const showReportStatus = _.get(
    userProfile,
    ['view_clients', 'show_report_status'],
    false
  )

  const clientsDataSync = _.get(
    userProfile,
    ['view_clients', 'show_sync_status'],
    false
  )

  return {
    currentUseCases,
    isTextReportVisible,
    isTBFeedbackVisible,
    isCovidFeedbackVisible,
    hasGeneExpertTBTest,
    hasTBLampTBTest,
    hasCOVIDTests,
    hasTests,
    hasFeedback,
    hasDicomUpload,
    hasPngUpload,
    hasEnableAddVisit,
    hasEnableEditClient,
    xrayViewerHeaderFindings,
    dashboardHeaderFindings,
    tests,
    viewClientTags,
    hasFullReportDownloadable,
    hasHotSpotMap,
    hasTBScoreViewClients,
    hasNoduleScoreViewClients,
    hasTBScoreViewer,
    hasColoredUploadDisclaimer,
    hasLiveUpdateOnClientList,
    isEditingReportEnabled,
    isTabularReportEnabledOnEdit,
    enabledTreatmentDetails,
    enableAdditionalTestsFields,
    isExternalReportShareEnabled,
    XRayHeaderFindings,
    isReportDownloadEnabled,
    testsKeys,
    dashboardDataSync,
    isTBREnabled,
    isNoduleFeedbackVisible,
    hasNoduleScoreViewer,
    showReportStatus,
    scoreType,
    clientsDataSync
  }
}

export default getFeatureToggles
